import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconCartStyle0 = stylesCss;

const BiIconCart$1 = /*@__PURE__*/ proxyCustomElement(class BiIconCart extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'e9da274416441bb5c957cbf67977ad4e654f0207', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '45307a7b7fca8bd915170e71418759bac1abacdb', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '4b0fb2efb60597525da2e183e441479b5a910c93', "fill-rule": 'evenodd', d: 'M9.118 7.32a3.748 3.748 0 0 1 3.745-3.745 3.748 3.748 0 0 1 3.746 3.744h3.245v10.986a3.247 3.247 0 0 1-3.246 3.246h-7.49a3.247 3.247 0 0 1-3.245-3.246V7.319h3.245Zm0 1.5v2.994h1.5V8.819h4.491v2.995h1.5V8.819h1.745v9.486c0 .963-.782 1.746-1.746 1.746h-7.49a1.747 1.747 0 0 1-1.745-1.746V8.819h1.745Zm5.991-1.5h-4.491a2.248 2.248 0 0 1 2.245-2.245 2.248 2.248 0 0 1 2.246 2.244Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconCartStyle0; }
}, [1, "bi-icon-cart", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-cart"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-cart":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconCart$1);
            }
            break;
    } });
}

const BiIconCart = BiIconCart$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconCart, defineCustomElement };
